export default __webpack_public_path__ + "static/media/Gilroy-Regular.f6c9931f.woff2";